import React from "react";
import PropTypes from "prop-types";
import SubstanceInfoDosageAxis from "./SubstanceInfoDosageAxis";
import SubstanceInfoDosageRoa from "./SubstanceInfoDosageRoa";
import DoseCalculator from "./DoseCalculator"; // Import nowego komponentu
import { detailedInteractions } from "./interactions"; // Import danych z interactions.js
import { classes } from './SubstanceInfoBasic';


const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "0px",
    marginBottom: "30px",
  },
  th: {
    width: "25%",
    borderBottom: "2px solid #aaa",
    background: "#f7f7f7",
    color: "#333",
    fontWeight: "500",
    padding: "10px 15px",
    textAlign: "left",
  },
  td: {
    borderBottom: "1px solid #ddd",
    padding: "10px 15px",
    color: "#666",
  },
  tr: {
    transition: "background 0.2s ease-in-out",
  },
  toggleButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '30px',
    gap: '20px',
  }, 
  toggleButton: {
    outline: '0',
    border: '0',
    cursor: 'pointer',
    background: '#FCFCFD',
    boxShadow: '0px 2px 4px rgb(45 35 66 / 40%), 0px 7px 13px -3px rgb(45 35 66 / 30%), inset 0px -3px 0px #d6d6e7',
    height: '48px',
    // padding: '0 32px',
    borderRadius: '6px',
    color: '#36395a',
    transition: 'box-shadow 0.15s ease, transform 0.15s ease',
    alignContent: 'center',
    flex: 1,
    textAlign: 'center',
    flexBasis: '0', // Add this line
    minWidth: '120px', // Optional: Set a minimum width for each button
  },
  activeButton: {
    backgroundColor: '#e0e0e0',
  },
  inactiveButton: {
    backgroundColor: '#ffffff',
  },
  card: {
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "0px 20px",
    margin: "30px 0px 0px",
    // color: "#666",
    whiteSpace: "pre-line",
    lineHeight: "1.7",
    backgroundColor: '#f9f9f9',
    fontSize: "14px",
    marginBottom: "20px"
  },
  roaDropdown: {
    marginTop: "20px",
    marginBottom: "20px",
    // display: "flex",
    // width: "auto"
  },
  dropdownContainer: {

    marginBottom: "10px",
    marginTop: "35px",
    display: "flex",
    alignItems: "center",
  },
  dropdown: {
    flexGrow: 1,
    marginLeft: "-10px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "5px",
    fontSize: "16px",
  },
  dropdownLabel: {
    marginRight: "10px",
    fontWeight: "bold",
    color: "#333",
  },
  interactionListItem: {
    marginBottom: "10px",
  },
  tooltipStyle: {
    position: 'fixed',
    left: '0%', // Przesuwa tooltip do prawej strony viewportu
    top: '0%', // Ustawia tooltip w poziomie na środku viewportu
    // transform: 'translate(-50%, -50%)', // Wyśrodkowuje tooltip względem punktu (left, top)
    backgroundColor: '#f9f9f9', // Jasne tło
    color: '#333', // Ciemne litery
    padding: '20px 20px 10px 20px',
    borderRadius: '5px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
    listStyle: 'inside',
    zIndex: '1000',
    margin: '20%'
  },
  tooltipHiddenStyle: {
    display: "none"
  },  
  uniqueTooltip: {
    fontSize: "12px", // Smaller font size
    margin: "0px 20px 15px 0px", // Spacing around the tooltip
    borderTop: "2px solid #9999", // Long line break
    paddingTop: "15px", // Padding to create space between the line and text
    color: "#808080", // Text color
  },
};

class SubstanceInfoDosage extends React.Component {
  static propTypes = {
    info: PropTypes.shape({
      tolerance: PropTypes.object,
      crossTolerances: PropTypes.arrayOf(PropTypes.string),
      interactions: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          status: PropTypes.string,
        })
      ),
      roas: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          dosage: PropTypes.array,
          duration: PropTypes.array,
        })
      ),
      classes: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string), // Jeśli classes jest tablicą
        PropTypes.object // Jeśli classes jest obiektem
      ]), // Add classes prop
    }).isRequired,
  };

  state = {
    activeTab: null,
    roaTabIndex: this.props.info.roas.length === 1 ? 0 : null,
  selectionCount: 0, // Track how many times ROA is selected
  substanceTooltipData: {}, // Stores tooltip data per substance
    showCalculator: false,
    calculatorUnit: 'μg',
    tooltipContent: null,
    tooltipShownOnce: false, // Tracks if the tooltip has already been shown for the current substance
    filterText: "", // Dodaj nowy stan do śledzenia tekstu wprowadzania
    showAllInteractions: false,  // Dodaj nowy stan do kontrolowania widoczności wszystkich interakcji
  };


  
  setActiveTab = (tab) => {
    this.setState((prevState) => ({
      activeTab: prevState.activeTab === tab ? null : tab,
    }));
  };

  setActiveRoaTab = (index) => {
    this.setState({ roaTabIndex: index });
  };

  handleShowAllInteractionsClick = () => {
    this.setState((prevState) => ({
      showAllInteractions: !prevState.showAllInteractions,
      filterText: ""  // Wyczyszczenie pola wyszukiwania
    }));
  };
  
  handleFilterChange = (event) => {
    this.setState({
      filterText: event.target.value.trim()  // Usuwamy końcowe spacje
    });
  };
  

  getTooltipText = (status) => {
    if (status.includes("Low Risk & Decrease")) {
      return "⬇️ Effects are subtractive. The combination is unlikely to cause any adverse or undesirable reaction beyond those that might ordinarily be expected from these drugs.";
    } else if (status.includes("Low Risk & No Synergy")) {
      return "🔵 Effects are additive. The combination is unlikely to cause any adverse or undesirable reaction beyond those that might ordinarily be expected from these drugs.";
    } else if (status.includes("Low Risk & Synergy")) {
      return "⬆️ These drugs work together to cause an effect greater than the sum of their parts, and they aren't likely to cause an adverse or undesirable reaction when used carefully. Additional research should always be done before combining drugs.";
    } else if (status.includes("Caution")) {
      return "⚠️ These combinations are not usually physically harmful, but may produce undesirable effects, such as physical discomfort or overstimulation. Extreme use may cause physical health issues. Synergistic effects may be unpredictable. Care should be taken when choosing to use this combination.";
    } else if (status.includes("Unsafe")) {
      return "❤️‍🩹 There is considerable risk of physical harm when taking these combinations, they should be avoided where possible.";
    } else if (status.includes("Dangerous")) {
      return "❌ These combinations are considered extremely harmful and should always be avoided. Reactions to these drugs taken in combination are highly unpredictable and have a potential to cause death.";
    } else if (status.includes("Unknown")) {
      return "❓ Effects are unknown.";
    }
    return "";
  };

  
  isClassesArray = (classes) => {
    return Array.isArray(classes);
  };
  
  findDetailedInteraction = (substance1, substance2) => {
    // console.log("findDetailedInteraction called with:", substance1, substance2);
  
    let interaction = null;
  
// Helper function for class-based matching
const findByClass = () => {
  const mapClassToSubstance = (className) => {
    switch (className) {
      case "Lysergamides": return "LSD";
      case "MDxx": return "MDMA";
      case "Amphetamine": return "Amphetamines";
      case "Cannabinoid": return "Cannabis";
      case "Opioids": return "Opioids";
      case "Antidepressants": return "SSRIs";
      case "Benzodiazepines": return "Benzos";
      case "Alkanediol": return "GHB/GBL";
      default: return className;
    }
  };

  const classesArray = this.isClassesArray(this.props.info.classes)
    ? this.props.info.classes
    : Object.values(this.props.info.classes || {}).flat();

  for (const className of classesArray) {
    const mappedSubstance = mapClassToSubstance(className);

    // Check if there's a class-based interaction match for the first valid mapping
    const matchByClass = (interaction) => {
      const substance1Lower = interaction.substance1.toLowerCase();
      const substance2Lower = interaction.substance2.toLowerCase();
      
      // Exclude interactions with "CBD" or "Cannabidiol"
      if (["cbd", "cannabidiol"].includes(substance1Lower) || ["cbd", "cannabidiol"].includes(substance2Lower)) {
        return false;
      }
    
      return (mappedSubstance === interaction.substance1 && interaction.substance2 === substance2) ||
             (mappedSubstance === interaction.substance2 && interaction.substance1 === substance1);
    };

    const interaction = detailedInteractions.find(matchByClass);

    if (interaction) {
      // Return immediately after finding a match for the class (prevents further checks for other classes)
      return interaction;
    }
  }

  return null;
};
    // Helper function for pattern-based matching
    const findByPattern = () => {
      const mapSubstanceByPattern = (substanceName) => {
        if (/^2C-/.test(substanceName)) {
          // console.log("Pattern match for '2C-' found:", substanceName);
          return '2C-x';
        }
        if (/3C-B/.test(substanceName)) {
          return '2C-x';
        }
        if (/GHB|GBL|BDO/.test(substanceName)) {
          return 'GHB/GBL';
        }
        if (/NBOM/.test(substanceName)) {
          return 'NBOMes';
        }
        if (/NBOH/.test(substanceName)) {
          return 'NBOMes';
        }
        if (/NB3OM/.test(substanceName)) {
          return 'NBOMes';
        }
        if (/psilo/.test(substanceName)) {
          return 'Mushrooms';
        }
        if (/5-MeO/.test(substanceName)) {
          return '5-MeO-xxT';
        }
        if (/2C-T-/.test(substanceName)) {
          return '2C-T-x';
        }
        return substanceName;
      };
  
  
      const substance1Mapped = mapSubstanceByPattern(substance1);
      const substance2Mapped = mapSubstanceByPattern(substance2);
      // console.log("Substance 1 mapped by pattern:", substance1Mapped);
      // console.log("Substance 2 mapped by pattern:", substance2Mapped);
  
      const matchByPattern = (interaction) =>
        (interaction.substance1 === substance1Mapped && interaction.substance2 === substance2Mapped) ||
        (interaction.substance1 === substance2Mapped && interaction.substance2 === substance1Mapped);
  
      const interaction = detailedInteractions.find(matchByPattern);
      if (interaction) {
        // console.log("Pattern match found:", interaction);
        return interaction;
      }
      return null;
    };
  
    // Helper function for exact name match
    const findByExactName = () => {
      const matchByName = (interaction) => 
        (interaction.substance1 === substance1 && interaction.substance2 === substance2) ||
        (interaction.substance1 === substance2 && interaction.substance2 === substance1);
  
      const interaction = detailedInteractions.find(matchByName);
      if (interaction) {
        // console.log("Exact name match found:", interaction);
        return interaction;
      }
      return null;
    };
  
    // 1. Try finding an interaction by class-based matching first
    interaction = findByClass();
  
    // 2. Then try finding an interaction by pattern matching and overwrite if found
    const patternInteraction = findByPattern();
    if (patternInteraction) {
      interaction = patternInteraction;
    }
  
    // 3. Finally, try finding an interaction by exact name and overwrite if found
    const exactInteraction = findByExactName();
    if (exactInteraction) {
      interaction = exactInteraction;
    }
  
    if (interaction) {
      // console.log("Final interaction found:", interaction);
    } else {
      // console.log("No interaction found for substances:", substance1, substance2);
    }
  
    return interaction;
  };
  


  
  renderToleranceAndCrossTolerance() {
    const { info } = this.props;
    const { activeTab, filterText } = this.state;
  
    // Filtrowanie interakcji na podstawie wpisanego tekstu
    const filteredInteractions = info.interactions
      ? info.interactions.filter(({ name }) => 
          name.toLowerCase().includes(filterText.toLowerCase())
        )
      : [];
  
      let visibleEmojis = new Set();  // Tworzymy zestaw na widoczne emoji

      const interactionTexts = filteredInteractions.length > 0
        ? filteredInteractions.map(({ name, status }, index) => {
            let emoji = "";
            let interactionType = "";
      
            if (status.includes("Low Risk & Decrease")) {
              emoji = "⬇️";
              interactionType = "Low Risk & Decrease";
            } else if (status.includes("Low Risk & No Synergy")) {
              emoji = "🔵";
              interactionType = "Low Risk & No Synergy";
            } else if (status.includes("Low Risk & Synergy")) {
              emoji = "⬆️";
              interactionType = "Low Risk & Synergy";
            } else if (status.includes("Caution")) {
              emoji = "⚠️";
              interactionType = "Caution";
            } else if (status.includes("Unsafe")) {
              emoji = "❤️‍🩹";
              interactionType = "Unsafe";
            } else if (status.includes("Dangerous")) {
              emoji = "❌";
              interactionType = "Dangerous";
            } else if (status.includes("Unknown")) {
              emoji = "❓";
              interactionType = "Unknown";
            }
      
            // Dodajemy widoczne emoji do zestawu
            visibleEmojis.add(emoji);
      
            const detailedInteraction = this.findDetailedInteraction(info.name, name);
      
            return (
              <div key={index} style={styles.interactionListItem}>
                {emoji} {name} – {interactionType}
                {detailedInteraction && (
                  <div style={{ fontSize: "0.9em", color: "#999", marginLeft: "1.5em" }}>
                    {detailedInteraction.description}
                  </div>
                )}
              </div>
            );
          })
        : (
          <div style={{ paddingBottom: "15px" }}>
            No interactions match your search.
          </div>
        );
  
    // Obsługa sekcji Cross-tolerance i toleranceTexts
    const toleranceTexts = info.tolerance
      ? Object.entries(info.tolerance)
          .filter(([name, value]) => value !== null && value !== "null" && value.trim() !== "")
          .map(([name, value]) => {
            return `<strong>${name.charAt(0).toUpperCase() + name.slice(1)}:</strong> ${value}`;
          })
          .join("\n")
      : "";
  
      let crossToleranceText = "";
      if (info.crossTolerances && info.crossTolerances.length > 0) {
        if (info.crossTolerances.length === 1) {
          const lastWord = info.crossTolerances[0].split(" ").pop();
          crossToleranceText = lastWord.endsWith("s")
            ? `<div style="padding-bottom: 20px;"><strong>Cross-tolerance:</strong> ${info.crossTolerances[0]}</div>`
            : `<div style="padding-bottom: 20px;"><strong>Cross-tolerance:</strong> ${info.crossTolerances[0]} compounds</div>`;
        } else {
          const allButLast = info.crossTolerances.slice(0, -1).join(", ");
          const last = info.crossTolerances[info.crossTolerances.length - 1];
          const lastWord = last.split(" ").pop();
          crossToleranceText = lastWord.endsWith("s")
            ? `<div style="padding-bottom: 20px;"><strong>Cross-tolerance:</strong> ${allButLast} and ${last}</div>`
            : `<div style="padding-bottom: 20px;"><strong>Cross-tolerance:</strong> ${allButLast} and ${last} compounds</div>`;
        }
      }
      
  
    const uniqueTooltips = 
      Array.from(
        new Set(
          (info.interactions || [])
            .flatMap(({ status }) => this.getTooltipText(status))
        )
      );
  
    const showCalculator = 
      Object.values(info.classes || {}).flat().some((name) =>
        name.toLowerCase().includes("lysergamide") || name.toLowerCase().includes("tryptamine")
      ) && toleranceTexts.toLowerCase().includes("day");
  
    const calculatorUnit = Object.values(info.classes || {}).flat().some((name) =>
      name.toLowerCase().includes("lysergamide")
    )
      ? "μg"
      : "g";
  
    let content = null;
    if (activeTab === "tolerance") {
      content = (
        <>
          {toleranceTexts ? (
            <div style={{ padding: '20px 0px' }} dangerouslySetInnerHTML={{ __html: toleranceTexts }} />
          ) : (
            <p style={{ margin: '1em 0em'}}>Cross-tolerance expected with compounds from the same class.</p>
          )}
          {crossToleranceText && (
            <div dangerouslySetInnerHTML={{ __html: crossToleranceText }} />
          )}
          {showCalculator && (
            <div style={{ marginTop: '-20px', paddingBottom: '0px' }}>
              <DoseCalculator classes={info.classes} unit={calculatorUnit} />
            </div>
          )}
        </>
      );
    } else if (activeTab === "interactions") {
      content = (
        <div>
          {/* Dodaj pole input do filtrowania interakcji */}
          <input 
            type="text" 
            placeholder="Search interactions..." 
            value={filterText} 
            onChange={this.handleFilterChange} 
            style={{ margin: '20px 0px', padding: '8px', width: '-webkit-fill-available' }} 
          />
<p style={{ marginBottom: "0", marginTop: "0" }}>
  Interactions increase risks. Details are listed below if available.{' '}
<span 
  onClick={this.handleShowAllInteractionsClick} 
  style={{ textDecoration: 'underline', cursor: 'pointer' }}>
  {this.state.showAllInteractions ? 'Hide all interactions' : 'Show all interactions'}
</span>    </p>     
<div style={{ marginTop: "20px", marginBottom: "10px" }}>
{(this.state.showAllInteractions || this.state.filterText.length > 0) && interactionTexts}
          </div>
          {(this.state.showAllInteractions || this.state.filterText.length > 0) && (
  <div style={styles.tooltipList}>
    {uniqueTooltips
      .filter(tooltip => visibleEmojis.has(tooltip.substring(0, 2)))  // Filtruj tooltipy na podstawie emoji
      .map((tooltip, index) => (
        <div key={index} style={styles.uniqueTooltip}>{tooltip}</div>
      ))}
  </div>
)}


        </div>
      );
    }
  

    return (
      <div>
        <div style={styles.toggleButtonContainer}>
          {/* Interactions button comes first now */}
          <div
            style={{
              ...styles.toggleButton,
              ...(activeTab === "interactions" ? styles.activeButton : {}),
              ...styles.answerButton,
            }}
            onClick={() => this.setActiveTab("interactions")}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            onMouseDown={(e) => (e.currentTarget.style.transform = "translateY(2px)")}
            onMouseUp={(e) => (e.currentTarget.style.transform = "translateY(0)")}
          >
            Interactions
          </div>
    
          {/* Tolerance button comes second now */}
          <div
            style={{
              ...styles.toggleButton,
              ...(activeTab === "tolerance" ? styles.activeButton : {}),
              ...styles.answerButton,
            }}
            onClick={() => this.setActiveTab("tolerance")}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            onMouseDown={(e) => (e.currentTarget.style.transform = "translateY(2px)")}
            onMouseUp={(e) => (e.currentTarget.style.transform = "translateY(0)")}
          >
            Tolerance
          </div>
        </div>
    
        {content && <div style={styles.card}>{content}</div>}
      </div>
    );
  }    

  handleInfoClick = () => {
    alert(
      'Select a method of ingestion to compare dosage and duration of effects.'
    );
  };
  
  renderRoasTabs() {
    const { info } = this.props;
    const { roaTabIndex } = this.state;
  
    if (!info.roas || info.roas.length === 0) {
      return null; // Do not render if there are no ROAs
    }
  
  
    const filteredRoas = info.roas.filter(
      (roa) =>
        (roa.dosage && roa.dosage.length > 0) ||
        (Array.isArray(roa.duration) && roa.duration.length > 0)
    );
  
    return (
      <div>
        {/* Header with the Route of administration and Info icon */}
        <div
          style={{
            paddingTop: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
            marginBottom: "20px",
          }}
        >
          <h2 style={{ margin: 0 }}>Route of administration</h2>
          <i
            className="zmdi zmdi-info-outline"
            style={{ marginLeft: '10px', cursor: 'pointer', padding: '10px' }} 
            onClick={this.handleInfoClick} // Triggers the alert
          ></i>
        </div>
  
        {/* Dropdown for ROA */}
        <div style={styles.roaDropdown}>
          <div style={styles.dropdownContainer}>
            <label style={styles.dropdownLabel}></label>
            <select
              style={styles.dropdown}
              value={roaTabIndex === null ? "" : roaTabIndex}
              onChange={this.handleDropdownChange}
            >
              <option value="" disabled={filteredRoas.length <= 1}>
                Select a route of administration
              </option>
              {filteredRoas.map((roa, index) => (
                <option key={index} value={index}>
                  {roa.name.replace(/_/g, " ")}
                </option>
              ))}
            </select>
          </div>
  
          {roaTabIndex !== null && (
            <>
              <SubstanceInfoDosageAxis
                roa={filteredRoas[roaTabIndex]}
                roas={filteredRoas}
                visible={true}
              />
              <SubstanceInfoDosageRoa
                roa={filteredRoas[roaTabIndex]}
                visible={true}
              />
            </>
          )}
        </div>
      </div>
    );
  }
  
  handleDropdownChange = (event) => {
    const value = event.target.value;
    const substanceName = this.props.info.name;
    
    this.setActiveRoaTab(value === "" ? null : parseInt(value, 10));
    const selectedRoa = this.props.info.roas[parseInt(value, 10)];
    
    if (selectedRoa) {
      const bioavailability = selectedRoa.bioavailability || "unknown";
  
      const { substanceTooltipData } = this.state;
      const currentSubstanceData = substanceTooltipData[substanceName] || {
        selectionCount: 0,
        tooltipShownOnce: false,
      };
  
      // Calculate relative bioavailability if not done already
      if (!this.state.relativeBioavailabilityCalculated) {
        const relativeBioavailability = this.calculateRelativeBioavailability(this.props.info.roas);
        this.setState({
          tooltipContent: {
            bioavailability,
            relativeBioavailability,
          },
          relativeBioavailabilityCalculated: true,
        });
      } else {
        this.setState({
          tooltipContent: {
            bioavailability,
            relativeBioavailability: this.state.tooltipContent.relativeBioavailability,
          },
        });
      }
  
      // Increment selectionCount and check if it's the second time
      const newSelectionCount = currentSubstanceData.selectionCount + 1;
      const newSubstanceData = {
        ...currentSubstanceData,
        selectionCount: newSelectionCount,
        tooltipShownOnce: currentSubstanceData.tooltipShownOnce || newSelectionCount >= 2,
      };
  
      this.setState((prevState) => ({
        substanceTooltipData: {
          ...prevState.substanceTooltipData,
          [substanceName]: newSubstanceData,
        },
      }), () => {
        // Show tooltip only after the second selection
        if (newSubstanceData.selectionCount >= 2) {
          this.setState({
            tooltipVisible: true,
            tooltipPosition: {
              x: event.clientX,
              y: event.clientY,
            },
          });
        }
      });
    }
  };
  
  
  
  // Close tooltip on click outside
  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
    console.log(this.props.info.classes); // Wydrukuj `classes` po zamontowaniu komponentu

    // Set default ROA tab if there is only one option
    if (this.props.info.roas.length === 1) {
      this.setState({ roaTabIndex: 0 });
    }
    
  }
  
  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
  
  handleOutsideClick = (event) => {
    if (this.tooltipRef && !this.tooltipRef.contains(event.target) && this.state.tooltipVisible) {
      this.setState({ tooltipVisible: false });
    }
  }
  
  
  

  parseDosageValue(value) {
    const unitMatch = value.match(/[a-zA-Z]+$/);
    const unit = unitMatch ? unitMatch[0] : "";

    const numericValue = value.replace(unit, "").trim();

    if (numericValue.includes("-")) {
      const [min, max] = numericValue.split("-").map((num) => parseFloat(num.trim()));
      if (!isNaN(min) && !isNaN(max)) {
        const average = (min + max) / 2;
        const roundedAverage = average > 20 ? Math.round(average / 5) * 5 : Math.round(average);
        return { min: roundedAverage, max: roundedAverage, unit };
      }
    }

    const number = parseFloat(numericValue);
    if (!isNaN(number)) {
      const roundedNumber = number > 20 ? Math.round(number / 5) * 5 : Math.round(number);
      return { min: roundedNumber, max: roundedNumber, unit };
    }
    return { min: 0, max: 0, unit: "" };
  }

  calculateRelativeBioavailability = (roas) => {
  const commonDoses = roas
    .map((roa) => {
      // Check if roa and roa.dosage are valid
      if (roa && Array.isArray(roa.dosage)) {
        const commonDose = roa.dosage.find((d) => d.name === "Common");
        if (commonDose) {
          const { min } = this.parseDosageValue(commonDose.value);
          if (!isNaN(min) && min > 0) {  // Ensure valid and positive dose
            return { name: roa.name, min };
          }
        }
      }
      return null;
    })
    .filter(Boolean);

  if (commonDoses.length === 0) {
    return [];
  }

  // Determine the most potent (smallest dose) route
  const mostPotent = commonDoses.reduce((min, dose) => (dose.min < min.min ? dose : min), commonDoses[0]);

  // Calculate relative bioavailability percentages
  const relativeBioavailabilityResults = commonDoses.map((dose) => {
    const relativeBioavailability = ((mostPotent.min / dose.min) * 100).toFixed(0); // Should divide most potent by current
    return {
      name: dose.name,
      relativeBioavailability,
    };
  }).sort((a, b) => a.relativeBioavailability - b.relativeBioavailability);


  return relativeBioavailabilityResults;
};
    
  render() {
    const { info } = this.props;
    const { tooltipContent, tooltipVisible, tooltipPosition } = this.state;
    
    // Update tooltip position if needed
    const tooltipStyle = {
      ...styles.tooltipStyle,
      display: tooltipVisible ? 'block' : 'none', // Show tooltip only when tooltipVisible is true
      // left: tooltipPosition?.x || 0,
      // top: tooltipPosition?.y || 0
    };
    

    const tooltipHiddenStyle = styles.tooltipHiddenStyle;

  
    return (
      <div>
        {this.renderToleranceAndCrossTolerance()}
        {info.roas && this.renderRoasTabs()}  
        {/* Tooltip for Bioavailability */}
        {tooltipVisible && tooltipContent && (
            <div
              style={tooltipVisible ? tooltipStyle : tooltipHiddenStyle}
              ref={el => this.tooltipRef = el} // Save reference to tooltip element
              onClick={() => this.setState({ tooltipVisible: false })} // Close tooltip on click
            >
                                <i
          className="zmdi zmdi-close"
          style={{ cursor: 'pointer', transform: 'translateX(190px) translateY(-10px)' }} // Dostosuj stylowanie ikony zamknięcia
          onClick={() => this.setState({ tooltipVisible: false })}
        />
              {tooltipContent.bioavailability && (
                <div style={{ marginBottom: 10 }}>
                  <strong>Bioavailability:</strong> {tooltipContent.bioavailability}
                </div>
              )}
              {tooltipContent.relativeBioavailability && tooltipContent.relativeBioavailability.length > 0 && (
                <div>
                  <strong>Relative bioavailability:</strong>
                  <ul>
                    {tooltipContent.relativeBioavailability.map((item, index) => (
                      <li key={index}>{item.name}: {item.relativeBioavailability}%</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
                </div>
    );
  }
  


}

export default SubstanceInfoDosage;
